import { createContext, FC, PropsWithChildren, RefObject, useContext, useRef, useState } from 'react';

interface CompanyAdminLayoutContextProps {
  containerElementRef: RefObject<HTMLElement>;
  isMenuOpen: boolean;
  setIsMenuOpen: (value: boolean | ((prev: boolean) => boolean)) => void;
  isDrawerOpen: boolean;
  setIsDrawerOpen: (value: boolean | ((prev: boolean) => boolean)) => void;
}

const CompanyAdminLayoutContext = createContext<CompanyAdminLayoutContextProps>(undefined!);

export const CompanyAdminLayoutProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const containerElementRef = useRef<HTMLElement>(null!);

  return (
    <CompanyAdminLayoutContext.Provider
      value={{ containerElementRef, isMenuOpen, setIsMenuOpen, isDrawerOpen, setIsDrawerOpen }}
    >
      {children}
    </CompanyAdminLayoutContext.Provider>
  );
};

export function useCompanyAdminLayoutContext(): CompanyAdminLayoutContextProps {
  const context = useContext(CompanyAdminLayoutContext);

  if (typeof context === 'undefined') {
    throw new Error('useCompanyAdminLayoutContext should be used within the CompanyAdminLayoutContext provider!');
  }

  return context;
}

